






































































import { Component, Prop, Vue } from 'vue-property-decorator';

const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;

@Component({})
export default class DetailsForm extends Vue {

  @Prop(Function) private onComplete!: (Object) => void;
  @Prop(Boolean) private isLoading!: boolean;


  private zxcvbn;
  private email: string = '';
  private username: string = '';
  private password: string = '';
  private passwordConfirm: string = '';
  private twoFactor: boolean = true;


  get passwordErrorMessage() {
    if (this.password === '') {
      return false;
    }
    if (this.password.length < 8) {
      return 'Password should be at-least 8 characters long';
    }
    const validation = this.zxcvbn.default(this.password, [this.email, this.username]);
    if (validation.score < 3) {
      return `Password should be a mix of letter, numbers & special characters. ${validation.feedback.warning}`;
    }
    if (this.password !== this.passwordConfirm) {
      return 'Password and its confirm do not match.';
    }
    return false;
  }

  protected async created() {
    this.zxcvbn = await import('zxcvbn');
  }

  protected onSubmit(e) {
    e.preventDefault();
    if (this.passwordErrorMessage !== false) {
      return;
    }
    this.onComplete({
      email: this.email,
      username: this.username,
      password: this.password,
      twoFactor: this.twoFactor
    });
  }

}

